/* eslint-disable react-hooks/exhaustive-deps */
import { initial_interests, thingsToLearn } from "constants/thingsToLearn";
import { useAuth } from "context/useAuth";
import { useFormik } from "formik";
import * as Yup from "yup";
import BlankLayout from "layout/BlankLayout";
import { extend, map, omit } from "lodash";
import { LOGIN_USER } from "query/mutation";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import InteresetSelectionForm from "views/Interest/components/InteresetSelectionForm";
import { useActivity } from "context/useActivity";

const date = new Date().getTime();

const Interest = () => {
  const [isFormSubmitted, setFormIsSubmitted] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { setActivityCtx } = useActivity();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loginUser = useMutation(LOGIN_USER, {
    onSuccess: () => {
      setFormIsSubmitted(true);
      setHasError(false);
    },
    onError: () => {
      setFormIsSubmitted(false);
      setHasError(true);
    },
  });

  const selectionFormik = useFormik({
    initialValues: {
      user_id: date,
      username: "",
      emailAddress: "",
      age: 1,
      selected_favourite: [] as string[],
      selected_interests: [] as string[],
      initial_favorites: thingsToLearn,
      initial_interests: initial_interests,
      mode: "put user info",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      emailAddress: Yup.string().required("Email is required"),
      age: Yup.number()
        .min(1, "Age must be min of 1")
        .required("Age is required"),
      selected_favourite: Yup.array()
        .min(5, "You must select atleast 5 items")
        .required("Favourite is required"),
    }),
    onSubmit: (values) => {
      const selectedFavourite = map(thingsToLearn, (things: string) => {
        if (values.selected_favourite.includes(things)) {
          return true;
        }
        return false;
      });
      const selectedIntereset = map(initial_interests, (interest) => {
        if ((values?.selected_interests || []).includes(interest)) {
          return true;
        }
      });
      loginUser.mutate(
        omit(
          extend(values, {
            checked_favorites: selectedFavourite,
            checked_interests: selectedIntereset,
            age: String(values.age),
          }),
          ["selected_favourite", "selected_interests"]
        )
      );
    },
  });

  const handleContinue = () => {
    if (loginUser.isSuccess) {
      const selectedFavourite = map(thingsToLearn, (things: string) => {
        if (selectionFormik.values.selected_favourite.includes(things)) {
          return true;
        }
        return false;
      });
      const selectedIntereset = map(initial_interests, (interest) => {
        if (
          (selectionFormik.values?.selected_interests || []).includes(interest)
        ) {
          return true;
        }
      });
      setUser(
        omit(
          extend(selectionFormik.values, {
            cycle: 1,
            checked_favorites: selectedFavourite,
            checked_interests: selectedIntereset,
            age: String(selectionFormik.values.age),
          }),
          ["selected_favourite", "selected_interests"]
        )
      );
      setActivityCtx({
        cycle_number: 1,
      });
      navigate("/review-interests");
    }
  };

  useEffect(() => {
    handleContinue();
  }, [loginUser.isSuccess]);

  return (
    <BlankLayout>
      <>
        <div className="section">
          <div className="container">
            <div className="intro-wrap">
              <div className="text-block">
                Before we begin the study, we need some information about you:
              </div>
              <InteresetSelectionForm
                selectionFormik={selectionFormik}
                isFormSubmitted={isFormSubmitted}
                hasError={hasError}
              />
            </div>
          </div>
        </div>
        <div className="section-2 wf-section">
          <div className="w-container">
            <div className="text-block-2">
              Please submit your responses before continuing the study.{" "}
            </div>
          </div>
          {!isFormSubmitted && !hasError && (
            <div className="container-3 w-container">
              <button
                className="button-2 w-button"
                onClick={() => selectionFormik.handleSubmit()}
              >
                {loginUser.isLoading ? "loading..." : "SUBMIT YOUR RESPONSES"}
              </button>
            </div>
          )}
          {isFormSubmitted && !hasError && (
            <div className="container-4 w-container">
              <button
                onClick={handleContinue}
                className="submit-button w-button"
                style={{
                  pointerEvents: Boolean(isFormSubmitted && !hasError)
                    ? "auto"
                    : "none",
                  cursor: Boolean(isFormSubmitted && !hasError)
                    ? "pointer"
                    : "not-allowed",
                }}
              >
                CONTINUE STUDY
              </button>
            </div>
          )}
        </div>
      </>
    </BlankLayout>
  );
};

export default Interest;
